import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
let _promise = null;

export function useGiftCards() {
    const [cards, setCards] = useState(_cache || []);
    useEffect(() => {
        if (_cache) { setCards(_cache); return; }
        if (!_promise) {
            _promise = api.get("/giftcards").then((r) => {
                _cache = r.data || [];
                return _cache;
            }).catch(() => { _cache = []; return _cache; });
        }
        _promise.then((data) => setCards(data));
    }, []);
    return cards;
}

export function findGiftCardByCode(cards, code) {
    return (cards || []).find((c) => c.code === code) || null;
}
